import { html } from 'lit';
import type { TefComsTriStateButton } from '@mfe-4cs/components/TefComsTriStateButton';

export function triStateButtonsPartTemplate(this: TefComsTriStateButton, buttonType: string, type: string) {
  return html`
    <one-button
      data-testid="${this.consent.id}-${this.buttonType}"
      size="small"
      flexible
      .variant=${this.variant}
      .checked=${this.checked}
      @click=${() => { this.handleClick(type); }}
      ?disabled="${this.disabled}"
      color="${this.color}"
      style="${!buttonType ? 'margin-left: -1px;' : ''}"
    >
      <one-icon name=${this.icon}></one-icon>
    </one-button>
  `;
}
